import {
  connectorMeetsMinVersion,
  getConnectorVersion,
  isConnectorInWindowsExclusiveKillRange,
} from './connectorVersion';

/** Web client requires this Connector build for core local-library IPC. */
export const MIN_SUPPORTED_CONNECTOR = '11.0.150';

/** Bit-perfect / exclusive USB DAC playback (includes post–kill-switch builds). */
export const MIN_BIT_PERFECT_CONNECTOR = '11.0.165';

export function isConnectorBelowMinimumSupported(): boolean {
  const v = getConnectorVersion();
  if (!v) return false;
  return !connectorMeetsMinVersion(v, MIN_SUPPORTED_CONNECTOR);
}

/** True when local-native / exclusive playback must be blocked in the UI. */
export function isConnectorBitPerfectBlocked(): boolean {
  return isConnectorBelowMinimumSupported()
    || isConnectorInWindowsExclusiveKillRange();
}

/** True when exclusive FFI and bit-perfect zones are supported on this Connector. */
export function isConnectorBitPerfectCapable(): boolean {
  const v = getConnectorVersion();
  if (!v) return false;
  if (isConnectorInWindowsExclusiveKillRange()) return false;
  return connectorMeetsMinVersion(v, MIN_BIT_PERFECT_CONNECTOR);
}

export function connectorMinimumSupportedBannerMessage(): string {
  const v = getConnectorVersion();
  const label = v ? `v${v.replace(/^v/i, '')}` : 'unknown';
  return `Your Maestro Connector (${label}) is out of date and must be updated to keep working. Download the latest version at maestrodesktop.com.`;
}

export function connectorBitPerfectRequiredMessage(): string {
  return `Bit-perfect playback requires connector v${MIN_BIT_PERFECT_CONNECTOR} or later — please update.`;
}

/** Call before selecting local-native or starting exclusive play. Returns message if blocked. */
export function bitPerfectBlockedMessage(): string | null {
  if (!isConnectorBitPerfectBlocked()) return null;
  if (isConnectorBelowMinimumSupported()) {
    return connectorMinimumSupportedBannerMessage();
  }
  return connectorBitPerfectRequiredMessage();
}
